<template>
  <v-card outlined>
    <v-card-text>
      <div class="text-h6 font-weight-bold mb-2">
        {{ totalStudent }} Pending Application
      </div>
      <div>
        <div ref="pieContainer" style="width: 100%; height: 300px"></div>
      </div>
      <v-list dense style="max-height: 350px; overflow: auto">
        <template v-for="item in classesList">
          <v-list-item
            @click="openStudentList(item)"
            :key="item.name"
            v-if="item.totalStudentLeads !== 0"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle v-if="item.maleStudentLeads !== 0"
                >{{ item.maleStudentLeads }} - Male
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.femaleStudentLeads !== 0"
                >{{ item.femaleStudentLeads }} - Female
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action-text class="font-weight-bold">{{
              item.totalStudentLeads
            }}</v-list-item-action-text>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    totalStudent: {
      type: Number,
      default: 0,
    },
    classesList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  // mounted() {
  //   this.renderPie();
  // },
  watch: {
    classesList: {
      handler() {
        // this.renderPie();
        this.renderDoc();
      },
      deep: true,
    },
  },
  methods: {
    renderPie() {
      const categories = this.classesList.map((row) => row.name);
      const values = this.classesList.map((row) => row.totalStudentLeads);

      // Prepare data in { name, y } format for Highcharts pie
      const pieData = categories.map((name, index) => ({
        name,
        y: values[index],
      }));

      Highcharts.chart(this.$refs.pieContainer, {
        credits: { enabled: false },
        chart: {
          type: "pie",
        },
        title: { text: null },
        tooltip: {
          pointFormat: "<b>{point.y} students</b> ({point.percentage:.1f}%)",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.y}",
            },
            showInLegend: true,
          },
        },
        colors: [
          "#4BC0C0",
          "#36A2EB",
          "#FFCE56",
          "#8E5EA2",
          "#FF6384",
          "#36A200",
        ],
        series: [
          {
            name: "Applications",
            colorByPoint: true,
            data: pieData,
          },
        ],
      });
    },
    renderDoc() {
      const categories = this.classesList.map((row) => row.name);
      const values = this.classesList.map((row) => row.totalStudentLeads);

      const showDataLabels = !this.$vuetify.breakpoint.xsOnly;
      // Prepare data in { name, y } format for Highcharts pie
      const pieData = categories.map((name, index) => ({
        name,
        y: values[index],
      }));

      Highcharts.chart(this.$refs.pieContainer, {
        credits: { enabled: false },
        chart: {
          type: "pie",
        },
        title: { text: null },
        tooltip: {
          pointFormat: "<b>{point.y} students</b> ({point.percentage:.1f}%)",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            innerSize: "60%", // 👈 makes it a doughnut
            dataLabels: {
              enabled: showDataLabels,
              format: "<b>{point.name}</b>: {point.y}",
            },
            showInLegend: false,
          },
        },
        colors: [
          "#4BC0C0",
          "#36A2EB",
          "#FFCE56",
          "#8E5EA2",
          "#FF6384",
          "#36A200",
        ],
        series: [
          {
            name: "Applications",
            colorByPoint: true,
            data: pieData,
          },
        ],
      });
    },
    openStudentList(item) {
      this.$router.push({
        path: "/applications/list",
        query: { ClassId: item.id, ClassName: item.name },
      });
    },
  },
};
</script>

<style scoped>
</style>